export default function Vision2030Section() {
  return (
    <section
      className='mx-auto grid grid-cols-12 gap-5 bg-neutral-100 px-4 py-12 text-white md:px-16'
      id='vision-2030'
      style={{
        backgroundImage:
          "url('https://mcdn.coolmate.me/image/March2025/mceclip3_198.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className='text-heading-5 md:text-heading-1 col-span-12 font-criteria !font-normal leading-none'>
        Tầm nhìn <br className='hidden md:block' />
        Coolmate <span className='!font-semibold'>2030</span>
      </div>

      <div className='col-span-12 mt-10 w-full overflow-x-auto md:mt-20'>
        <div className='relative max-md:min-w-[1530px]'>
          {/* Top row */}
          <div className='grid grid-cols-9 gap-4 2xl:grid-cols-10'>
            <div className='relative col-span-2 col-start-2 flex max-w-56 flex-col justify-end 2xl:col-start-3'>
              <div className='flex flex-col items-center'>
                <div className='mb-10 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    Trở thành thương hiệu thời trang <strong>dẫn đầu</strong>{' '}
                    Việt Nam.
                  </p>
                </div>
              </div>
              <div className='absolute -bottom-2 left-1/2 -translate-x-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
            <div className='relative col-span-2 flex max-w-56 flex-col justify-end'>
              <div className='flex flex-col items-center'>
                <div className='mb-10 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    Mở rộng kênh phân phối offline, chiếm tối thiểu{' '}
                    <strong>40%</strong> doanh thu.
                  </p>
                </div>
              </div>
              <div className='absolute -bottom-2 left-1/2 -translate-x-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
            <div className='relative col-span-2 flex max-w-56 flex-col justify-end'>
              <div className='flex flex-col items-center'>
                <div className='mb-10 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    Mở rộng phân khúc khách hàng sang nữ và trẻ em, chiếm{' '}
                    <strong>40%</strong> doanh thu.
                  </p>
                </div>
              </div>
              <div className='absolute -bottom-2 left-1/2 -translate-x-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
            <div className='relative col-span-2 flex max-w-56 flex-col justify-end'>
              <div className='flex flex-col items-center'>
                <div className='mb-10 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    Ưu tiên <strong>chất lượng cuộc sống</strong> cho nhân viên
                    và đối tác sản xuất.
                  </p>
                </div>
              </div>
              <div className='absolute -bottom-2 left-1/2 -translate-x-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
          </div>

          <div className='h-[2px] w-full bg-neutral-100'></div>

          {/* Bottom row */}
          <div className='grid grid-cols-9 gap-4 2xl:grid-cols-10'>
            <div className='relative col-span-2 col-start-1 max-w-56 2xl:col-start-2'>
              <div className='flex flex-col items-center'>
                <div className='mt-12 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    Doanh thu <strong>500 triệu USD</strong>, tăng trưởng trung
                    bình <strong>50%/năm</strong>
                  </p>
                </div>
                <div className='mt-3 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    EBITDA trên <strong>10%</strong>; định giá{' '}
                    <strong>1 tỷ USD</strong> (Unicorn)
                  </p>
                </div>
              </div>
              <div className='absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
            <div className='relative col-span-2 max-w-56'>
              <div className='flex flex-col items-center'>
                <div className='mt-12 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    <strong>Đa dạng hóa</strong> sản phẩm: quần áo, giày dép và
                    phụ kiện.
                  </p>
                </div>
              </div>
              <div className='absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
            <div className='relative col-span-2 max-w-56'>
              <div className='flex flex-col items-center'>
                <div className='mt-12 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    Phát triển thị trường <strong>Đông Nam Á và Mỹ</strong>,
                    đóng góp <strong>30%</strong> doanh thu.
                  </p>
                </div>
              </div>
              <div className='absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
            <div className='relative col-span-2 max-w-56'>
              <div className='flex flex-col items-center'>
                <div className='mt-12 rounded-lg border border-neutral-400 bg-black p-4 text-white'>
                  <p className='text-base'>
                    Đầu tư mạnh vào <strong>đổi mới</strong> sản phẩm và{' '}
                    <strong>tối ưu hóa</strong> sản xuất.
                  </p>
                </div>
              </div>
              <div className='absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 transform'>
                <div className='h-4 w-4 rounded-full border border-[#939393] bg-black'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
